export default __webpack_public_path__ + "static/media/dishant.05742923.png";